import type { ComponentProps } from 'react';
import type React from 'react';

import { Spinner } from '@change/ds-core-ui';

import { Image } from '@change-corgi/design-system-legacy/components/media';
import { Flex } from '@change-corgi/design-system-legacy/layout';

import { useProcessedImage } from '#src/app/shared/hooks/image';

type PhotoProps = {
	aspectRatio: '1/1' | '16/9';
	processing: boolean;
	alt: string;
	src: string;
};

export const Photo: React.FC<PhotoProps & ComponentProps<typeof Image>> = ({
	aspectRatio,
	processing,
	src,
	alt,
	...rest
}) => {
	const image = useProcessedImage({ url: src, processing });

	if (image.processing) {
		return (
			<Flex
				sx={{ overflow: 'hidden', aspectRatio, alignItems: 'center', justifyContent: 'center', height: '100%' }}
				aria-hidden="true"
				// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
				{...(rest as any)}
			>
				<Spinner className="size-4" />
			</Flex>
		);
	}

	return (
		<Image
			src={image.url}
			alt={alt}
			fit="cover"
			sx={{
				aspectRatio,
				verticalAlign: 'top',
				height: '100%',
			}}
			loading="lazy"
			{...rest}
		/>
	);
};
